import React from "react";

export default function AGB() {
  return (
    <main className="mx-auto max-w-4xl px-6 py-12 text-gray-800 leading-relaxed">
      <h1 className="text-2xl font-bold mb-6">Allgemeine Geschäftsbedingungen (AGB)</h1>

      <h2 className="text-xl font-semibold mt-8 mb-3">1. Geltungsbereich</h2>
      <p>
        Diese AGB gelten für alle Verträge zwischen <strong>GVSI Clean & Care</strong> 
         <br/>und unseren Kunden über Reinigungs- und Gebäudeserviceleistungen.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">2. Vertragsschluss</h2>
      <p>
        Ein Vertrag kommt durch unsere schriftliche Auftragsbestätigung oder
        durch die tatsächliche Ausführung der Dienstleistung zustande.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">3. Leistungen</h2>
      <p>
        Umfang, Art und Häufigkeit der Reinigung werden individuell vereinbart.
        Änderungen und Zusatzleistungen bedürfen der schriftlichen Bestätigung.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">4. Preise & Zahlung</h2>
      <p>
        Unsere Preise verstehen sich in Euro inkl. gesetzlicher Umsatzsteuer.
        Rechnungen sind innerhalb von 14 Tagen ohne Abzug fällig.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">5. Haftung</h2>
      <p>
        Wir haften für Schäden, die nachweislich durch unser Personal verursacht
        wurden, im Rahmen unserer Betriebshaftpflichtversicherung.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">6. Kündigung</h2>
      <p>
        Dauerschuldverhältnisse können mit einer Frist von 4 Wochen zum Monatsende
        gekündigt werden, soweit nichts anderes vereinbart wurde.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">7. Gerichtsstand</h2>
      <p>
        Es gilt deutsches Recht. Gerichtsstand ist der Sitz von GVSI Clean & Care.
      </p>
    </main>
  );
}
